export const CampusRef: { [id: string]: string; } = {
    "A": "Colchester",
    "K": "Southend",
    "2": "Colchester"
};